import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Modal, Row} from 'reactstrap';
import {TT_CLOSE, TT_SAVE} from "../../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import Separator from "../../../../components/Separator";
import {GenericButton} from "../../../../components/buttons/customButtons";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {productProvider} from "../../../../providers/productProvider";
import Switch from "react-bootstrap-switch";
import {showToastCustom} from "../../../../components/toast/customToast";
import {error, selectOption} from "../../../../components/i18n/i18n";
import {productPromotionService} from "../../../../jwt/_services/promotions/productPromotionService";
import {useForm} from "react-hook-form";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {menuService} from "../../../../jwt/_services";

export const PromotionProductForm = forwardRef((props, ref) => {
    const path = props.path;

    
    const [app, setApp] = useState( props.app || null );

    const [status, setStatus] = useState(false);
    const [samePromotionStatus, setSamePromotionStatus] = useState(true);
    const [loading, setLoading] = useState(false);
    const [promotion, setPromotion] = useState(null);
    const [packageId, setPackageId] = useState(null);
    const [productId, setProductId] = useState(null);
    const [productSubstituteId, setProductSubstituteId] = useState(null);

    const [editMode, setEditMode] = useState(false);

    const [showModal, setShowModal] = useState(true);
    const modalRef = useRef(null);
    
    const [modal, setModal] = useState(false);
    const [item, setItem] = useState(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(item);
    }

    const {register, handleSubmit, reset} = useForm({});

    useImperativeHandle(ref, () => ({
        showModal(_item, _index, _parent) {

            setItem( _item );
            setEditMode( !!_item?.id );

            setPackageId(_item?.packageId || '');
            setProductId(_item?.product?.id || null);
            setProductSubstituteId(_item?.productSubstitute?.id || null);
            setStatus(_item?.status !== null ? _item?.status : true);
            setSamePromotionStatus( _item?.samePromotionStatus !== null ? _item?.samePromotionStatus : true );
            setPromotion(_parent || null);

            setModal(!modal);
        }
    }));


    // ----------------------------------------------
    //            SUBMIT
    // ----------------------------------------------
    const onSubmit = (_) => {
        if ( productId === null || productId === undefined || productId === '')
            return showToastCustom(error, selectOption);

        const dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                id: item?.id,
                packageId: packageId,
                status: status,
                samePromotionStatus: samePromotionStatus,
                product: { id : productId },
                promotion: { id : promotion?.id },
            }
        };

        if (productSubstituteId !== null && productSubstituteId !== undefined && productSubstituteId !== '')
            dataRequest.item.productSubstitute = { id : productSubstituteId }
        else
            dataRequest.item.productSubstitute = null


        if (!editMode) {
            console.log('save',  dataRequest);
            // return;
            genericIndexedActions.save(path, productPromotionService, dataRequest)
        }
        else {
            let id = item?.menu?.id;
            dataRequest.id = item?.menu?.id;

            console.log('update',  dataRequest);
            // return;
            genericIndexedActions.update(path, productPromotionService, id, dataRequest)
        }
        closeForm()
    };

    const closeForm = () => {
        setModal(!modal);
    }

    return (<>
            <Modal isOpen={modal} toggle={setModal} modalClassName="menu-modal-form-medium">
                <Card  className={'card-modal'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <>
                            <h2 className={'card-modal-title'} > { 'Producto en promoción ' + promotion?.code?.toUpperCase() }</h2>
                            <br />
                        </>
                        <div className="top-right">
                            <GenericButton
                                style={'table'}
                                toolTip={TT_SAVE}
                                icon={'fa-save'}
                                permission={'add'}
                                onClick={onSubmit}
                            />
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={closeForm}
                            />
                        </div>
                    </CardTitle>
                    <CardBody className={'card-body-modal'}>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Producto</Label>
                                    <br />
                                    {
                                        editMode ?
                                            <Input type="text" name="product"
                                                   value={ item.productSivexCode + " - " + item.productName }
                                                   innerRef={register}
                                                   disabled={true}
                                            />
                                            :
                                            <SelectGeneric
                                                initialValue={ productId }
                                                setExternalValue={ setProductId }
                                                provider = { productProvider }
                                            />
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Producto subsituto</Label>
                                    <br/>
                                    <SelectGeneric
                                        initialValue={productSubstituteId}
                                        setExternalValue={setProductSubstituteId}
                                        provider={productProvider}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label>Id del paquete</Label>
                                    <Input type="text" name="packageId"
                                           placeholder="Ingrese id de paquete."
                                           innerRef={register}
                                           value={packageId}
                                           onChange={e => setPackageId(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label>Activo</Label>
                                    <br/>
                                    <Switch animate={true} offText={"No"} onText={"Si"}
                                            value={status}
                                            onChange={() => setStatus(!status)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label>{'Mantener mistmo estatus que la promoción'}</Label>
                                    <br/>
                                    <Switch animate={true} offText={"No"} onText={"Si"}
                                            value={samePromotionStatus}
                                            onChange={() => setSamePromotionStatus(!samePromotionStatus)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <br />
                        <br />
                        <br />
                    </CardBody>
                    {
                        showModal && <LogHistoryModal
                            ref={ modalRef }
                            item={ item }
                        />
                    }
                </Card>
            </Modal>
        </>
    )
})
